export default "__VITE_ASSET__b7512400__"